<template>
  <div class="form-group text-start">
    <span
      for="position"
      class="mb-2 fw-bold"
    >
      {{ label }}
      <span
        v-if="sublabel"
        class="fw-normal"
      >
        {{ sublabel }}
      </span>
    </span>
    <div class="position-relative mt-1">
      <div class="input-group">
        <input
          :id="inputId"
          :value="display"
          class="form-control cursor-pointer text-start bg-white custom-select"
          :class="[validationClass, { open: open }, { 'disabled-bg': inputDisabled }]"
          :disabled="inputDisabled"
          readonly="true"
          :placeholder="placeholder"
          @click="toggleOpen"
          @change="handleChange"
        >
      </div>
      <div
        v-if="selectedLength > 3"
        class="text-end mt-1 small"
      >
        {{ selectedLength }} sélectionnés
      </div>
      <transition
        name="slide"
        tag="div"
      >
        <div
          v-if="isOpen"
          :class="{ 'd-flex flex-column position-absolute w-100 pb-3': isOpen }"
          style="top: 60px"
        >
          <div
            :id="`autocomplete-list-${inputId}`"
            class="bg-white w-100 dropdown-select"
            style="max-height: 260px"
          >
            <div
              v-for="(item, index) in list"
              :key="item.code + '-' + index"
              class="d-flex btn btn-block w-100 font-weight-normal border-bottom justify-content-between"
              @click="setCustomModel(item)"
            >
              <div class="my-auto">
                {{ item.name || item.label }}
              </div>
              <div
                class="radio-circle"
                :class="{ 'bg-blue-700': isSelected(item) }"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { debounce } from 'lodash-es';
import input from '@/mixins/input-2';
import ClickOutside from 'vue-click-outside';

export default defineComponent({
  name: 'CustomMultiSelect',
  directives: {
    ClickOutside,
  },
  mixins: [input],
  props: {
    list: {
      type: Array,
      required: true,
    },
    sublabel: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    isSelectedFunction: {
      type: Function,
      required: true,
    },
  },
  emits: ['input', 'change'],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    selectedLength() {
      return this.customValue.filter(this.isSelectedFunction).length;
    },
    isOpen() {
      return this.open && this.list.length > 0;
    },
    display() {
      return this.customValue
        .filter(this.isSelectedFunction)
        .map(({ label }) => label)
        .join(', ');
    },
  },
  methods: {
    setCustomModel(value) {
      if (this.inputDisabled) return;
      if (value.id === 'NONE') {
        this.customValue = this.customValue.map((item) => Object.assign(item, { enabled: item.id === 'NONE' }));
      } else {
        this.customValue = this.customValue.map((item) => {
          if (item.id === 'NONE') {
            return Object.assign(item, { enabled: false });
          }
          if (item.id === value.id) {
            return Object.assign(item, { enabled: !item.enabled });
          }
          return item;
        });
      }
      this.debouncer.cancel();
      const debouncerFunction = async () => {
        try {
          await this.$store.dispatch(
            this.setterPath,
            this.setterFunction(this.customValue, this.path || this.getterName),
          );
        } catch (err) {
          this.errorCallback(err);
        } finally {
          this.setterCallback();
        }
      };
      this.debouncer = debounce(debouncerFunction, this.debounceTimer);
      this.debouncer();
    },
    toggleOpen() {
      if (this.inputDisabled) return;
      this.open = !this.open;
    },
    isSelected(item) {
      const duplicateItem = this.customValue.find(({ id }) => id === item.id);
      if (duplicateItem) {
        return this.isSelectedFunction(duplicateItem);
      }
      return this.isSelectedFunction(item);
    },
    handleChange(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    },
  },
});
</script>

<style scoped>
.dropdown-select {
  border: 2px solid #bfc9d6;
  border-radius: 15px;
  z-index: 10;
  overflow-y: scroll;
}
.disabled-bg {
  background-color: #e9ecef !important;
}
.btn-block {
  border-radius: 0;
  min-height: 56px;
}
.btn-block:hover {
  background-color: #edf4fd;
}
.btn-block:focus {
  box-shadow: none;
  border-radius: 8px;
}
.radio-circle {
  width: 20px;
  height: 20px;
  border: 2px solid var(--bs-blue-700);
  border-radius: 50%;
  position: relative;
  transition: background-color 0.3s ease;
}
</style>
